export const getFilterStorageKey = (page: string) => `${page}Filters.v2`;
